import NoticeList from "./NoticeList";
import { formatNoticeLocal } from "./noticeTheme";

export default function NoticesOverlay({ items, blocking, blockEndsAt, onDismiss }) {
  return (
    <div style={styles.backdrop} role="dialog" aria-modal="true" aria-label="Notices">
      <div style={styles.panel}>
        <div style={styles.header}>
          <h2 style={{ margin: 0, fontSize: 18 }}>Notices</h2>
          <button type="button" onClick={onDismiss} aria-label="Dismiss" style={styles.x}>
            ×
          </button>
        </div>
        {blocking ? (
          <div style={styles.blockBanner}>
            The portal is unavailable until {formatNoticeLocal(blockEndsAt)}. You can
            dismiss this list, but the portal stays blocked until maintenance ends.
          </div>
        ) : null}
        <div style={{ padding: 16 }}>
          <NoticeList items={items} />
        </div>
        <div style={styles.footer}>
          <button type="button" onClick={onDismiss}>
            Continue
          </button>
        </div>
      </div>
    </div>
  );
}

const styles = {
  backdrop: {
    position: "fixed",
    inset: 0,
    background: "rgba(0,0,0,0.45)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    zIndex: 1200,
    padding: 16,
  },
  panel: {
    background: "#fff",
    borderRadius: 10,
    width: "min(640px, 100%)",
    maxHeight: "90vh",
    overflow: "auto",
    boxShadow: "0 20px 40px rgba(0,0,0,0.2)",
  },
  header: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "14px 16px",
    borderBottom: "1px solid #e5e7eb",
  },
  x: {
    border: "none",
    background: "transparent",
    fontSize: 24,
    cursor: "pointer",
    lineHeight: 1,
  },
  blockBanner: {
    padding: "10px 16px",
    background: "#7f1d1d",
    color: "#fff",
    fontSize: 14,
  },
  footer: {
    padding: "0 16px 16px",
    display: "flex",
    justifyContent: "flex-end",
  },
};
